import React from 'react';
import PropTypes from 'prop-types';
import { t } from '../../../services/i18nService';
import styles from '../QuestionDisplay.scss';

const defaultState = {
    expanded: true,
};

class FeedbackForQuestion extends React.PureComponent {
    constructor(props, context) {
        super(props, context);
        this.state = defaultState;
    }

    toggleHeader = () => {
        this.setState({
            expanded: !this.state.expanded,
        });
    }

    getHeaderClass() {
        return `${styles.feedbackHeader} ${styles.feedbackHeaderUnChecked}`;
    }

    render() {
        const feedbackType = 'text';
        const feedbackHeaderCaption = t('questionFeedback.header');

        return (
            <div className={`${styles.feedbackForAlternative} feedbackForAlternative ${feedbackType}`}>
                <div className={this.getHeaderClass()}>
                    <button id="feedback_label" className={styles.toggle} aria-expanded={this.state.expanded} onClick={this.toggleHeader}>
                        <i className={`fa ${this.state.expanded ? 'fa-chevron-down' : 'fa-chevron-right'}`} aria-hidden />
                        <span className={`${styles.feedbackOn}`}>{feedbackHeaderCaption}</span>
                    </button>
                </div>

                {this.state.expanded ?
                    <div aria-labelledby="feedback_label" className={styles.feedbackBody}>
                        <React.Fragment>
                            <div
                                dangerouslySetInnerHTML={{ __html: ` ${this.props.inlineFeedback} ` }}
                                className="text"
                            />
                        </React.Fragment>
                    </div>
                    :
                    null
                }
            </div>
        );
    }
}

FeedbackForQuestion.propTypes = {
    inlineFeedback: PropTypes.string.isRequired,
};

export default FeedbackForQuestion;
